import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import './sessionCountdownToast.css';
import { getLocalStorageItem } from '../../../utils';
import { LOCAL_STORAGE, ROLES, ROUTES } from '../../../constants';
import { useDispatch } from 'react-redux';
import { setSessionPopup } from '../../../redux';

const MODAL_OFFSET = 5 * 60 * 1000;

const SessionCountdownToast = () => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [isActiveSession, setIsActiveSession] = useState(true);
    const [timeLeft, setTimeLeft] = useState(null); // in ms
    let timer = useRef(null);
    const role = useSelector((state) => state.user.role);
    const userId = getLocalStorageItem(LOCAL_STORAGE.USER_ID);

    //// NOTE: below is align to the current refresh-token expiry time ////
    const refreshExpiry = role === ROLES.USER ? 30 * 60 * 1000 : 180 * 60 * 1000;

    const handleLogout = useCallback(() => {
        dispatch(setSessionPopup(false));
        setIsActiveSession(false);
        setVisible(true);
        localStorage.clear();
        dispatch({ type: 'reset/store' });
        window.location.href = ROUTES.HOME;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const loginAt = parseInt(getLocalStorageItem(LOCAL_STORAGE.LOGIN_AT), 10);
        if (!loginAt || !userId) return;

        const expiryTime = loginAt + refreshExpiry;
        const startToastAt = expiryTime - MODAL_OFFSET;

        const tick = () => {
            const now = Date.now();
            const timeRemaining = expiryTime - now;

            if (timeRemaining <= 0) {
                handleLogout();
                clearInterval(timer.current);
                return;
            }

            if (now >= startToastAt) {
                setVisible(true);
                setTimeLeft(timeRemaining);
            }
        };

        // run immediately
        tick();
        // Run every second
        timer.current = setInterval(tick, 1000);

        // Also run when tab becomes active again
        window.addEventListener('focus', tick);

        return () => {
            clearInterval(timer?.current);
            window.removeEventListener('focus', tick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshExpiry, userId]);

    if (!visible || timeLeft === null) return null;

    const minutes = Math.floor(timeLeft / 60000)
        .toString()
        .padStart(2, '0');
    const seconds = Math.floor((timeLeft % 60000) / 1000)
        .toString()
        .padStart(2, '0');

    const toastColorClass = minutes >= 2 ? 'toast-warning' : 'toast-danger';

    return (
        <div className='session-toast-wrapper'>
            <div className={`session-toast ${toastColorClass}`}>
                {isActiveSession
                    ? `⏳ Your session expires in ${minutes}:${seconds}`
                    : 'Your session has expired!'}
            </div>
        </div>
    );
};

export default SessionCountdownToast;
